/**
 * Supplier Company Merge API — CR-5901
 *
 * Wraps the backend endpoints under /core/admin/supplier-merges/ that
 * power the Admin Setup → Suppliers merge UI.
 */
import api, { type AxiosResponse, type PaginatedResponse } from './client';

export interface SupplierMergeTableResult {
  updated: number;
  ignored: number;
  skipped?: boolean;
}

export interface SupplierMergePreview {
  results: Record<string, SupplierMergeTableResult>;
  totals: { updated: number; ignored: number };
}

export interface SupplierMergeLog {
  id: number;
  correct_company_id: number | null;
  correct_company_name: string;
  incorrect_company_id: number | null;
  incorrect_company_name: string;
  performed_by: number | null;
  performed_by_name: string;
  performed_at: string;
  status: 'preview' | 'success' | 'failed';
  status_display: string;
  results: Record<string, SupplierMergeTableResult>;
  totals: { updated: number; ignored: number };
  error_message: string;
}

export interface ExecuteMergePayload {
  correct_company_id: number;
  incorrect_company_id: number;
}

export interface SelectableSupplier {
  id: number;
  name: string;
  is_active: boolean;
}

const BASE = '/core/admin/supplier-merges/';

export const companyMergeAPI = {
  listHistory: (): Promise<AxiosResponse<PaginatedResponse<SupplierMergeLog>>> =>
    api.get(BASE),

  selectable: (): Promise<AxiosResponse<{ results: SelectableSupplier[] }>> =>
    api.get(`${BASE}selectable/`),

  preview: (payload: ExecuteMergePayload): Promise<AxiosResponse<SupplierMergePreview>> =>
    api.post(`${BASE}preview/`, payload),

  execute: (payload: ExecuteMergePayload): Promise<AxiosResponse<SupplierMergeLog>> =>
    api.post(BASE, payload),
};
